import React from 'react';
import { ColorModeContext } from '.';

function useColorMode() {
  const context = React.useContext(ColorModeContext);

  if (!context) {
    throw new Error('useColorMode must be used within a ColorModeProvider');
  }

  return context;
}

export { useColorMode };
